@if (appearance === 'labeled') {
  <button
    type="button"
    [matMenuTriggerFor]="flags"
    [attr.aria-label]="('change language' | translate) + ': ' + selectedLanguage?.language"
    class="flex items-center gap-2! h-10 px-3! bg-transparent border border-[#d5dbd6] rounded-lg text-sm font-medium text-[#18231c] cursor-pointer"
  >
    <img [src]="selectedLanguage?.icon" alt="" aria-hidden="true" class="language-flag rounded-circle object-cover icon-20" />
    {{ selectedLanguage?.language }}
    <i-tabler name="chevron-down" class="icon-14 d-flex" />
  </button>
} @else {
  <button [matMenuTriggerFor]="flags" mat-icon-button class="m-r-5 d-flex justify-content-center align-items-center">
    <img [src]="selectedLanguage?.icon" class="rounded-circle object-cover icon-20" />
  </button>
}
<mat-menu #flags="matMenu" [class]="'cardWithShadow p-0 ' + menuClass">
  @for (lang of languages; track lang.icon) {
    @if (appearance === 'labeled') {
      <button mat-menu-item [lang]="lang.code" class="language-menu-item" [class.active]="lang.code === selectedLanguage?.code" (click)="changeLanguage(lang)">
        <div class="flex items-center justify-between gap-3! w-full">
          <span class="flex items-center gap-2.5!">
            <img [src]="lang.icon" alt="" aria-hidden="true" class="language-flag rounded-circle object-cover icon-20" />
            <span class="f-s-14">{{ lang.language }}</span>
          </span>
          @if (lang.code === selectedLanguage?.code) {
            <i-tabler name="check" class="language-check icon-16 d-flex" />
          }
        </div>
      </button>
    } @else {
      <button mat-menu-item (click)="changeLanguage(lang)">
        <div class="d-flex align-items-center">
          <img [src]="lang.icon" class="rounded-circle object-cover m-r-8 icon-20" />
          <span class="f-s-14">{{ lang.language }}</span>
        </div>
      </button>
    }
  }
</mat-menu>
